// Lifted directly from @atlaskit/flag.

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button } from '@trello/nachos/button';

import { ActionsType } from './types';
import styles from './Flag.less';

interface Props {
  actions: ActionsType;
  testId?: string;
}

const gridSize = 8;
const separatorWidth = gridSize * 2;
const defaultAppearanceTranslate = gridSize / 4;

export const FlagActions = (props: Props) => {
  const { actions = [], testId } = props;
  if (!actions.length) {
    return null;
  }

  const renderSeparator = (index: number) => {
    if (index === 0) {
      return null;
    }
    return (
      <div
        css={css`
          text-align: center;
          display: inline-block;
          width: ${separatorWidth}px;
        `}
        key={index + 0.5}
      >
        {actions[index - 1].type === 'link' && actions[index].type === 'link'
          ? '·'
          : ''}
      </div>
    );
  };

  return (
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        padding-top: ${gridSize}px;
        transform: ${`translateX(-${defaultAppearanceTranslate}px)`};
        align-items: center;
      `}
      data-testid={testId && `${testId}-actions`}
    >
      {actions.map((action, index) => [
        renderSeparator(index),
        action.type === 'link' ? (
          <a
            className={styles.actionLink}
            onClick={action.onClick}
            href={action.href}
            target={action.target}
            key={index}
          >
            {action.content}
          </a>
        ) : (
          <Button onClick={action.onClick} key={index}>
            {action.content}
          </Button>
        ),
      ])}
    </div>
  );
};
